/**
 * 用于处理新航班列表接口 展示航站楼， --不展示
 * @param {string} val
 * @returns {string}
 */
export default function getTerminal(val) {
    if (!val)
        return '';
    if (/-/.test(val))
        return '';
    if (val.indexOf('T') === -1)
        val = 'T' + val;
    return val || '';
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/getTerminal.js
// module id = null
// module chunks = 